import { useChat } from '@cockpitai/components/organisms/Chat/useChat'
import { routesPath } from '@cockpitai/constants/routesPath'
import { useChatStore } from '@cockpitai/store/chat'
import { useLevelNavigation } from '@cockpitai/store/navigation/useLevelNavigation'
import { useNavigate } from 'react-router-dom'

export const messagesStandard = {
  0: { question: 'Ver mais' },
  1: { question: 'Qual o valor da produção?' },
  2: {
    question: 'Qual a quantidade de simulações?',
  },
  3: { question: 'Qual a quantidade de contratos?' },
  4: { question: 'Qual valor atual de APÑEF?' },
}

export function useHome() {
  const navigate = useNavigate()

  const { onSubmit, setValue } = useChat()

  const { resetNavigation } = useLevelNavigation()

  const { setIsStartedChat } = useChatStore()

  const handleSelectOption = (type: 0 | 1 | 2 | 3 | 4) => {
    const message = messagesStandard[type]

    setValue('question', message.question)

    setIsStartedChat(true)

    resetNavigation()

    onSubmit()

    navigate(routesPath.dashboard.chat, { replace: true })
  }

  return {
    handleSelectOption,
  }
}
